import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { GET_PAYMENT_DATA_BY_TOKEN } from "../../operations/queries/operations/queries/get-payment-by-token.js";
const useGetPaymentDataByToken = ({
  onError,
  onCompleted
} = {}) => {
  const [getPaymentData, { loading, data, error }] = useLazyQuery(GET_PAYMENT_DATA_BY_TOKEN, {
    onError(error2) {
      console.error(error2);
      onError && onError({ reason: "QUERY", error: error2 });
    },
    onCompleted() {
      onCompleted && onCompleted("getPaymentByToken");
    }
  });
  const getPaymentDataByToken = React.useCallback(
    (token) => {
      if (!token.length) {
        console.error("Payment token cannot be empty");
        return;
      }
      if (token) {
        getPaymentData({ variables: { input: { token } } });
      }
    },
    [getPaymentData]
  );
  const queryResults = React.useMemo(
    () => ({
      data: data?.getPaymentByToken,
      isPaymentDataLoading: loading,
      error
    }),
    [data?.getPaymentByToken, error, loading]
  );
  return {
    ...queryResults,
    getPaymentDataByToken
  };
};
export {
  useGetPaymentDataByToken
};
//# sourceMappingURL=use-get-payment-by-token.js.map
